<template>
    <div class="main">

        <i style="display: block; margin-left: 5px;">Rotina criada para facilitar a alteração de nome dos alunos e servidores no educacenso</i>
        <i style="color: #ff0000; margin-left: 5px; display: block;">O sistema não realizará a substituição, caso encontre dois registros (homônimos) com o mesmo nome. Neste caso, a substituição terá que ser realizada manualmente.</i>
        <c-panel  class="u-mt-10" title="ALTERAÇÃO DIRETA DE NOME (ALUNO E SERVIDOR)" titleIcon='fas fa-user'>

            <el-form @submit.native.prevent="onSubmitAlteracaoNome" :model="dados" ref="dados" label-position="top">

                <el-row :gutter="10">
                    <el-col :xs="24" :sm="24" :md="24" v-if="($store.state.user.tipo > 3 && $store.state.user.tipo <= 8) || $store.state.user.tipo == 10">
                        <el-form-item key="instituicao">
                            <el-select v-model="dados.instituicao_id" filterable placeholder="Pesquisar Instituição">
                                <el-option v-for="(item, i) in $store.state.instituicoes" :key="i" :label="item.nome" :value="item.id"> </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row :gutter="10">
                    <el-col :xs="24" :sm="24" :md="24">
                        <el-form-item label="Nomes" prop="ref" :rules="[$requiredBlur]" key="ref">
                            <el-input placeholder="ex: CAUAN LEONE RODRIGUES AMORIM -- CAUAN LEONE RODRIGUES DE AMORIM" v-model="dados.ref" maxlength="191"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row :gutter="10">
                    <el-col :xs="24">
                        <el-form-item class="u-text-right u-mt-15">
                            <el-button type="primary" id="btn-modelo" native-type="submit">SUBSTITUIR</el-button>
                        </el-form-item>
                    </el-col>
                </el-row>

            </el-form>

        </c-panel>

    </div>
</template>
<script>

export default {
    data: () => ({
        dados: {
            ref: '',
            instituicao_id: ''
        }
    }),
    mounted () {

    },
    methods: {

        onSubmitAlteracaoNome(){

            if(!this.dados.ref || !this.dados.instituicao_id){

                window.eventBus.$emit('alert', {msg: 'Selecione a instituição e informa os nomes a serem substituídos.', type: 'warning'});
                return;
            }

            window.eventBus.$emit('loading', true);

            this.$axios.post(`${this.$store.state.config.baseUrlApi}/api/educacensoAuth/substituir-nome`, this.dados, this.$store.getters.getHeaderAuth).then(response => {

                 if(typeof response.data.erro !== 'undefined'){

                    window.eventBus.$emit('loading', false);
                    window.eventBus.$emit('alert', {msg: response.data.erro, type: 'warning'});

                }else{

                    window.eventBus.$emit('alert', {msg: 'Sucesso! - Operação realizada com Sucesso!', type: 'success'});
                    window.eventBus.$emit('loading', false);

                    this.dados.ref = '';
                }

            }).catch((error) => { this.$store.commit('throwException', error); window.eventBus.$emit('loading', false); });

        }
    },
    components:{  }
}
</script>